<section class="container-fluid">
  <div class="row">
    <div class="col-12" #filtersContainer>
      <form class="container-style mb-2" [formGroup]="formRentalReportFilter">
        <div class="row">
          <div class="d-flex justify-content-between mb-1 headers-container">
            <div class="filter-name"><b>Filtros</b></div>
            <div class="d-flex align-items-end gap-1">
              <app-custom-button *ngIf="changeFilters" [title]="'Exportar'" [severity]="'success'"
                [icon]="'pi pi-file-excel'" (onClick)="exportExcel()"></app-custom-button>
              <app-custom-button *ngIf="changeFilters" [title]="'Imprimir'" [severity]="'primary'"
                [icon]="'pi pi-print'" (onClick)="printReport()"></app-custom-button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col filter-type-report">
            <app-custom-select formControlName="typeReport" [labelText]="'Tipo Informe'" [list]="listReportType"
              [recovery]="true" [required]="true" (onChangeSelect)="changeReportType($event)">
            </app-custom-select>
          </div>
          <div class="col filter-period">
            <app-custom-datepicker-report formControlName="dateInitial" [labelText]="'Período'" [recovery]="true"
              [required]="true" (onChangeDate)="changeFilter()"></app-custom-datepicker-report>
          </div>
          <div class="col filters">
            <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch" [recovery]="true"
              [required]="true" (onChangeSelect)="changeFilter()"></app-custom-select>
          </div>
          <div class="col filters">
            <app-custom-autocomplete formControlName="groupId" [labelText]="'Grupo'" [list]="listGroup"
              (onChangeSelect)="changeGroup($event)"></app-custom-autocomplete>
          </div>
          <div class="col filters">
            <app-custom-autocomplete formControlName="subgroupId" [labelText]="'Subgrupo'" [list]="filteredSubgroups"
              (onChangeSelect)="changeSubgroup($event)"></app-custom-autocomplete>
          </div>
          <div class="col filters">
            <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticle"
              (onChangeSelect)="changeArticle($event)"></app-custom-autocomplete>
          </div>
          <div class="col filters">
            <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventory"
              (onChangeSelect)="changeInventory($event)">
            </app-custom-select>
          </div>
          <div class="col filters">
            <app-custom-autocomplete formControlName="storeId" [labelText]="'Bodega'" [list]="filteredStores"
              (onChangeSelect)="changeStore($event)"></app-custom-autocomplete>
          </div>
          <div class="col field-buttons d-flex flex-row align-items-end gap-1">
            <app-custom-button [title]="'Recuperar'" [label]="'Recuperar'" [severity]="'primary'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [title]="'Limpiar'" [severity]="'secondary'" [icon]="'pi pi-eraser'"
              (onClick)="clear()"></app-custom-button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="custom-table-container" [hidden]="!changeFilters">
    <app-custom-table-report *ngIf="changeFilters" [dataReport]="dataReport"
      [filtersHeight]="filtersHeight"></app-custom-table-report>
  </div>
</section>